import request from "../utils/request";

export function getSalaryPage(data,pageNum,pageSize) {
    return request({
        url: '/salary/findPage',
        method: 'post',
        params: { pageNum: pageNum,pageSize:pageSize },
        data
    })
}

